import * as yup from "yup";

const inviteDriverScheme = yup.object().shape({
  email: yup
    .string()
    .matches(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Invalid email address",
    )
    .required("Email Id is required"),
  phoneNumber: yup
    .string()
    .required("Phone Number is required")
    .matches(/^\d{10}$/, "Invalid phone number"),
  name: yup.string().required("Name is required"),
  countryCode: yup.string().required("Country Code is required"),
});

export default inviteDriverScheme;
